import { isPositiveNumber, reduce } from "et3-type-guards";
import { ChatBubble, E_CHAT_MESSAGE_STATUS } from "et3-ui-library/mui";
import { DEFAULT_TIME } from "../../../../../../../constants/input-entries-constants";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import getKhattabat102Store from "../../../../../../../stores/khattabat-stores/102-stores";
import getKhattabatSharedMessagingStore from "../../../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";
import {
  E_KHATTABAT_CONVERSATION_TYPE,
  TKhattabatMessage
} from "../../../../../../../Types";
import KhattabatMessageContent from "./KhattabatMessageContent";
import OneOTwoMessageHiddenIndicator from "./OneOTwoMessageHiddenIndicator";
import OneOTwoMessageReactionBar from "./OneOTwoMessageReactionBar";
import SenderIcon from "./SenderIcon";

const KhattabatMessageBubble = withLiteObserverAndTheme<{
  khattabatMessage: TKhattabatMessage;
  isLastInSubGroup: boolean;
  conversationID: string;
  isOneOTwoConversation: boolean;
}>((props) => {
  const {
    khattabatMessage,
    isLastInSubGroup,
    conversationID,
    isOneOTwoConversation
  } = props;

  const isKhattabaMessage = isPositiveNumber(
    khattabatMessage.isKhattabaMessage
  );
  const isClientMessage = isPositiveNumber(khattabatMessage.isClientMessage);
  const reducedMessage = reduce(() => khattabatMessage.message, "");
  const reducedMessageType = reduce(() => khattabatMessage.messageType, "text");
  const reducedCreatedOn = reduce(
    () => khattabatMessage.createdOn,
    DEFAULT_TIME
  );
  const isSeenMessage = isPositiveNumber(khattabatMessage.isSeen);
  const reducedGender = reduce(() => khattabatMessage.senderGender, "m");

  const isOneOOneMConversation =
    getKhattabatSharedMessagingStore(conversationID).conversationType.get() ===
    E_KHATTABAT_CONVERSATION_TYPE.ONE_O_ONE_M;

  const khattabat102Store = getKhattabat102Store(conversationID);
  const messageId = khattabat102Store.getOneOTwoMessageId(khattabatMessage);
  const isOneOTwoMessage = isOneOTwoConversation && isPositiveNumber(messageId);

  const hasReactionHistory = isOneOTwoMessage
    ? khattabat102Store.getHasMessageReactionHistory(messageId)
    : false;
  const shouldRenderReactionBar = isOneOTwoMessage
    ? khattabat102Store.getShouldRenderMessageReactionBar(messageId)
    : false;
  const hasActiveHiddenAction = isOneOTwoMessage
    ? khattabat102Store.getHasActiveMessageHiddenAction(messageId)
    : false;

  return (
    <ChatBubble
      sender={getKhattabatSharedMessagingStore(conversationID).getMessageSender(
        isKhattabaMessage,
        reducedGender
      )}
      timestamp={reducedCreatedOn}
      status={
        isKhattabaMessage && isSeenMessage
          ? E_CHAT_MESSAGE_STATUS.SEEN
          : E_CHAT_MESSAGE_STATUS.NONE
      }
      avatar={
        isKhattabaMessage ? undefined : (
          <SenderIcon
            isLastInSubGroup={isLastInSubGroup}
            isKhattabaMessage={isKhattabaMessage}
            isClientMessage={isClientMessage}
            isOneOOneMConversation={isOneOOneMConversation}
            senderGender={reducedGender}
          />
        )
      }
      footer={
        shouldRenderReactionBar ? (
          <OneOTwoMessageReactionBar
            conversationID={conversationID}
            messageId={messageId}
            hasReactionHistory={hasReactionHistory}
            isKhattabaMessage={isKhattabaMessage}
            senderGender={reducedGender}
          />
        ) : undefined
      }
      aside={
        hasActiveHiddenAction ? (
          <OneOTwoMessageHiddenIndicator
            conversationID={conversationID}
            messageId={messageId}
          />
        ) : undefined
      }
    >
      <KhattabatMessageContent
        message={reducedMessage}
        messageType={reducedMessageType}
      />
    </ChatBubble>
  );
});

export default KhattabatMessageBubble;
